// extracted by mini-css-extract-plugin
module.exports = {"pitchesSpeedFieldWrapper":"PitchesSpeedField_pitchesSpeedFieldWrapper__12iAa","pitchesByZoneThumb":"PitchesSpeedField_pitchesByZoneThumb__2V5iz"};